/**
 * @param keys - массив ключей
 */

const defTypesCP = {
    "QuoteVolume": "Integer",
    "moveVol": "Integer",
    "OrderVol": "Integer",
    "NoShiftLimit": "Integer",
    "LimitBuy": "Integer",
    "StepPos": "Integer",
    "LimitSell": "Integer",
    "Priority": "Integer",
    "MinPos": "Integer",
    "BidUncrossOffset": "Float",
    "AskUncrossOffset": "Float",
    "VolumeWeight": "Float",
    "NoVolumePenalty": "Float",
    "D.Spread": "Float",
    "NormalSpread": "Float",
    "D_oc": "Float",
    "GO.HardOpen": "Float",
    "movePrice": "Float",
    "SprOpen": "Float",
    "SprClose": "Float",
    "StepSpread": "Float",
    "PriceDistance": "Float",
    "SpreadCoefDistance": "Float",
    "Cotir.def.param.group.ID": "String",
    "HedgeInstId": "String",
    "eLimitedMargin": "Boolean",
    "IsHedgeble": "Boolean",
    "UseTeorPrices": "Boolean",
}
const regInt = new RegExp("^[0-9]+$");
const regBool = new RegExp("^[0-1]+$");
const regDouble = new RegExp("^$|^(-?)(0|([1-9][0-9]*))(,[0-9]+)?$");
// const regDefeouble = new RegExp("^[-+]?[0-9]+(,[0-9]{3})*(\\.[0-9]+)?([eE][-+]?[0-9]+)?");

const cPTypeCheck = (key: string, value: string, typesCP : object = defTypesCP) => {

    const currentType = typesCP[key.split(" ")[0]]
    let isRightType = false
    switch (currentType) {
        case "Integer":
            isRightType = regInt.test(value)
            break
        case "Float":
            isRightType = regDouble.test(value)
            break
        case "Boolean":
            isRightType = regBool.test(value)
            break
        case "String":
            isRightType = true
            break
        default:
            break
    }
    return {currentType, isRightType};
}

export default cPTypeCheck
